<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect"; // add Multiselect
import language from "../../../helpers/list/language";

export default {
  components: { Multiselect },
  props: {},
  data() {
    return {
      language_id: [],
      skills: "",
      contributions: "",
      friends: "",
      link: "",
      experience: "",
      services: "",
      hours_days: "",
      details: "",
      telegram: "",
      facebook: "",
      instagram: "",
      twitter: "",

      //lists
      list_language: language,
    };
  },
  validations: {
    language_id: { required },
    skills: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(500),
    },
    contributions: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(500),
    },
    friends: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(500),
    },
    link: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(500),
    },
    experience: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(500),
    },
    services: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(500),
    },
    hours_days: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(500),
    },
    details: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(500),
    },
    telegram: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(250),
    },
    facebook: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(250),
    },
    instagram: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(250),
    },
    twitter: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(250),
    },
    form: [
      "skills",
      "friends",
      "link",
      "language_id",
      "contributions",
      "experience",
      "services",
      "hours_days",
      "details",
      "telegram",
      "facebook",
      "instagram",
      "twitter",
    ],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">المهارات والاعمال التطوعية</h5></div>

      <div class="col-md-12">
        <div class="row">
          <b-form-group
            class="col-md-12 mb-3"
            label=" اللغات التي تتحدثها . "
            label-for="language_id"
          >
            <multiselect
              id="language_id"
              select-label="حدد الاختيار"
              placeholder="اختر اللغات التي تتحدثها"
              deselect-label="اظغط هنا لمسح الاختيار"
              selected-label="تم اختياره"
              :options="list_language"
              track-by="id"
              label="name"
              :close-on-select="false"
              :clear-on-select="false"
              :multiple="true"
              v-model="language_id"
              :class="{ 'is-invalid': $v.language_id.$error }"
            >
              <template slot="singleLabel" slot-scope="{ option }"
                ><strong>{{ option.name }}</strong> is written in<strong>
                  {{ option.name }}</strong
                >
              </template>
            </multiselect>
            <div v-if="$v.language_id.$error" class="invalid-feedback">
              <span v-if="!$v.language_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-12 mb-3"
            label=" ما هي المهارات والمواهب والخبرات التي تملكها ؟ "
            label-for="skills"
          >
            <b-form-textarea
              id="skills"
              type="text"
              placeholder=" ادخل الاجابة"
              v-model="skills"
              :class="{ 'is-invalid': $v.skills.$error }"
              rows="3"
            ></b-form-textarea>
            <div v-if="$v.skills.$error" class="invalid-feedback">
              <span v-if="!$v.skills.minLength"
                >يجب أن يتكون هذا الحقل من 4 حروف على الاقل</span
              >
              <span v-if="!$v.skills.maxLength"
                >يجب أن يتكون هذا الحقل من 500 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-12 mb-3"
            label="اذا كان لديك مساهمات بدعم الحشد سابقاً سواء كانت مساهمات اعلامية او لوجستية او طبية او اي شكل من اشكال الدعم اذكرها ,
وتكلم عن تجربتك بدعم الحشد . "
            label-for="contributions"
          >
            <b-form-textarea
              id="contributions"
              type="text"
              placeholder="ادخل الاجابة"
              v-model="contributions"
              :class="{ 'is-invalid': $v.contributions.$error }"
              rows="3"
            ></b-form-textarea>
            <div v-if="$v.contributions.$error" class="invalid-feedback">
              <span v-if="!$v.contributions.required">هذا الحقل الزامي</span>
              <span v-if="!$v.contributions.minLength"
                >يجب أن يتكون هذا الحقل من 4 حروف على الأقل</span
              >
              <span v-if="!$v.contributions.maxLength"
                >يجب أن يتكون هذا الحقل من 500 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-12 mb-3"
            label=" هل لديك أقارب أو أصدقاء في الحشد الشعبي ؟
( اذكر اسماءهم و ارقام هواتفهم واماكن عملهم ان وجدت ) . "
            label-for="friends"
          >
            <!-- <span class="font-size-13 text-muted">اذكر اسماءهم و ارقام هواتفهم واماكن عملهم ان وجدت .</span> -->
            <b-form-textarea
              id="friends"
              type="text"
              placeholder="ادخل الاجابة"
              v-model="friends"
              :class="{ 'is-invalid': $v.friends.$error }"
              rows="3"
            ></b-form-textarea>
            <div v-if="$v.friends.$error" class="invalid-feedback">
              <span v-if="!$v.friends.required">هذا الحقل الزامي</span>
              <span v-if="!$v.friends.minLength"
                >يجب أن يتكون هذا الحقل من 4 حروف على الأقل</span
              >
              <span v-if="!$v.friends.maxLength"
                >يجب أن يتكون هذا الحقل من 500 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-12 mb-3"
            label=" كيف حصلت على رابط الاستمارة ؟
( اذكر اسم الصديق او المنصة الاعلامية التي حصلت من خلالها على الرابط ) . "
            label-for="link"
          >
            <b-form-textarea
              id="link"
              type="text"
              placeholder="ادخل الاجابة"
              v-model="link"
              :class="{ 'is-invalid': $v.link.$error }"
              rows="3"
            ></b-form-textarea>
            <div v-if="$v.link.$error" class="invalid-feedback">
              <span v-if="!$v.link.required">هذا الحقل الزامي</span>
              <span v-if="!$v.link.minLength"
                >يجب أن يتكون هذا الحقل من 4 حروف على الأقل</span
              >
              <span v-if="!$v.link.maxLength"
                >يجب أن يتكون هذا الحقل من 500 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-12 mb-3"
            label=" تكلم عن تجربتك في العمل التطوعي ( اذكر اسم فريق العمل التطوعي او المنظمة التي عملت فيها او التجربة التطوعية الفردية ان وجدت ) . "
            label-for="experience"
          >
            <b-form-textarea
              id="experience"
              type="text"
              placeholder="ادخل الاجابة"
              v-model="experience"
              :class="{ 'is-invalid': $v.experience.$error }"
              rows="3"
            ></b-form-textarea>
            <div v-if="$v.experience.$error" class="invalid-feedback">
              <span v-if="!$v.experience.required">هذا الحقل الزامي</span>
              <span v-if="!$v.experience.minLength"
                >يجب أن يتكون هذا الحقل من 4 حروف على الأقل</span
              >
              <span v-if="!$v.experience.maxLength"
                >يجب أن يتكون هذا الحقل من 500 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-12 mb-3"
            label=" ما هي الخدمات التطوعية التي تحب تقديمها للمجتمع ؟
(مثلا: عن طريق الاعلام , الفن , او عن طريق المهن الحرفية او التدريب او اي خدمة تستطيع ان تبدع في تقديمها) . "
            label-for="services"
          >
            <b-form-textarea
              id="services"
              type="text"
              placeholder="ادخل الاجابة"
              v-model="services"
              :class="{ 'is-invalid': $v.services.$error }"
              rows="3"
            ></b-form-textarea>
            <div v-if="$v.services.$error" class="invalid-feedback">
              <span v-if="!$v.services.required">هذا الحقل الزامي</span>
              <span v-if="!$v.services.minLength"
                >يجب أن يتكون هذا الحقل من 4 حروف على الأقل</span
              >
              <span v-if="!$v.services.maxLength"
                >يجب أن يتكون هذا الحقل من 500 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-12 mb-3"
            label=" كم ساعة او يوم تستطيع تقديمها لخدمة الناس بشكل تطوعي ؟  "
            label-for="hours_days"
          >
            <b-form-textarea
              id="hours_days"
              type="text"
              placeholder="ادخل الاجابة"
              v-model="hours_days"
              :class="{ 'is-invalid': $v.hours_days.$error }"
              rows="3"
            ></b-form-textarea>
            <div v-if="$v.hours_days.$error" class="invalid-feedback">
              <span v-if="!$v.hours_days.required">هذا الحقل الزامي</span>
              <span v-if="!$v.hours_days.minLength"
                >يجب أن يتكون هذا الحقل من 4 حروف على الأقل</span
              >
              <span v-if="!$v.hours_days.maxLength"
                >يجب أن يتكون هذا الحقل من 500 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-12 mb-3"
            label=" اذكر اي تفاصيل تود اضافتها . "
            label-for="details"
          >
            <b-form-textarea
              id="details"
              type="text"
              placeholder="ادخل الاجابة"
              v-model="details"
              :class="{ 'is-invalid': $v.details.$error }"
              rows="3"
            ></b-form-textarea>
            <div v-if="$v.details.$error" class="invalid-feedback">
              <span v-if="!$v.details.required">هذا الحقل الزامي</span>
              <span v-if="!$v.details.minLength"
                >يجب أن يتكون هذا الحقل من 4 حروف على الأقل</span
              >
              <span v-if="!$v.details.maxLength"
                >يجب أن يتكون هذا الحقل من 500 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <hr class="hr-title" />
          <div class="break-title">
            <h5 class="mb-4">مواقع التواصل الاجتماعي</h5>
          </div>
          <ul class="" style="margin-right: 16px">
            <li class="mb-1">
              <h5 class="font-size-14">اكتب "لا يوجد" اذا كنت لا تملك حسابا</h5>
            </li>
          </ul>
          <b-form-group
            class="col-md-3 mb-3"
            label="حساب التلكرام : "
            label-for="telegram"
          >
            <b-form-input
              id="telegram"
              type="text"
              placeholder="ادخل حساب التلكرام"
              v-model="telegram"
              :class="{ 'is-invalid': $v.telegram.$error }"
            ></b-form-input>
            <div v-if="$v.telegram.$error" class="invalid-feedback">
              <span v-if="!$v.telegram.required">هذا الحقل الزامي</span>
              <span v-if="!$v.telegram.minLength"
                >يجب أن يتكون الحساب من حرفين على الأقل</span
              >
              <span v-if="!$v.telegram.maxLength"
                >يجب أن يتكون الحساب من 250 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-3 mb-3"
            label="حساب الفيسبوك : "
            label-for="facebook"
          >
            <b-form-input
              id="facebook"
              type="text"
              placeholder="ادخل حساب الفيسبوك"
              v-model="facebook"
              :class="{ 'is-invalid': $v.facebook.$error }"
            ></b-form-input>
            <div v-if="$v.facebook.$error" class="invalid-feedback">
              <span v-if="!$v.facebook.required">هذا الحقل الزامي</span>
              <span v-if="!$v.facebook.minLength"
                >يجب أن يتكون الحساب من حرفين على الأقل</span
              >
              <span v-if="!$v.facebook.maxLength"
                >يجب أن يتكون الحساب من 250 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-3 mb-3"
            label="حساب الانستكرام : "
            label-for="instagram"
          >
            <b-form-input
              id="instagram"
              type="text"
              placeholder="ادخل حساب الانستكرام"
              v-model="instagram"
              :class="{ 'is-invalid': $v.instagram.$error }"
            ></b-form-input>
            <div v-if="$v.instagram.$error" class="invalid-feedback">
              <span v-if="!$v.instagram.required">هذا الحقل الزامي</span>
              <span v-if="!$v.instagram.minLength"
                >يجب أن يتكون الحساب من حرفين على الأقل</span
              >
              <span v-if="!$v.instagram.maxLength"
                >يجب أن يتكون الحساب من 250 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3" label="حساب تويتر : " label-for="twitter">
            <b-form-input
              id="twitter"
              type="text"
              placeholder="ادخل حساب تويتر"
              v-model="twitter"
              :class="{ 'is-invalid': $v.twitter.$error }"
            ></b-form-input>
            <div v-if="$v.twitter.$error" class="invalid-feedback">
              <span v-if="!$v.twitter.required">هذا الحقل الزامي</span>
              <span v-if="!$v.twitter.minLength"
                >يجب أن يتكون الحساب من حرفين على الأقل</span
              >
              <span v-if="!$v.twitter.maxLength"
                >يجب أن يتكون الحساب من 250 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
